(function () {
  function init() {
    var container = document.querySelector('[class*="trust_row_LbEssnc"] .section-content-wrapper');
    if (!container) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = container.querySelectorAll(':scope > .group-block');
    if (items.length < 2) return;

    var index = 0;
    var stopped = false;
    var isMobile = function () {
      return window.matchMedia('(max-width: 749px)').matches;
    };

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (eventName) {
      container.addEventListener(eventName, function () {
        stopped = true;
      }, { passive: true, once: true });
    });

    setInterval(function () {
      if (stopped || !isMobile()) return;
      index = (index + 1) % items.length;
      container.scrollTo({ left: items[index].offsetLeft, behavior: 'smooth' });
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
